(function () {
  'use strict';

  var root = document.getElementById('mbbNbx');
  if (!root || root.dataset.nbxReady === 'true') return;
  root.dataset.nbxReady = 'true';
  var grid = root.querySelector('#mbbNbxGrid');
  var cards = Array.from(grid.querySelectorAll('.mbb-nbx-card')).map(function (card, index) {
    return { node: card, initialIndex: index, price: Number(card.dataset.price),
      available: card.dataset.available !== 'false', types: card.dataset.types.trim().split(/\s+/) };
  });
  var selects = Array.from(root.querySelectorAll('[data-nbx-sort]'));
  var typeLinks = Array.from(root.querySelectorAll('[data-nbx-type]'));
  var types = typeLinks.map(function (link) { return link.dataset.nbxType; });
  var sorts = Array.from(selects[0].options).map(function (option) { return option.value; });
  var pagination = root.querySelector('[data-nbx-pagination]');
  var paginationReturn = root.querySelector('[data-nbx-pagination-return]');
  var pageSize = Math.max(1, Number(root.dataset.pageSize) || 16);
  var state = { sort: 'default', type: 'all', page: 1, all: false };
  var headerHeight = 0;

  // The shared header has no ID. Associate its existing H1 without changing its markup or styles.
  var sectionWrapper = root.closest('.shopify-section');
  var title = sectionWrapper && sectionWrapper.querySelector('.page-header .page-title');
  if (title) {
    if (!title.id) title.id = 'mbbNbxTitle';
    root.setAttribute('aria-labelledby', title.id);
    root.removeAttribute('aria-label');
  }

  function readHash() {
    var params = new URLSearchParams(window.location.hash.slice(1));
    state.sort = sorts.indexOf(params.get('sort')) !== -1 ? params.get('sort') : 'default';
    state.type = types.indexOf(params.get('type')) !== -1 ? params.get('type') : 'all';
    var page = Number(params.get('page'));
    state.page = Number.isSafeInteger(page) && page > 0 ? page : 1;
    state.all = params.get('all') === '1';
  }

  function hashFor(next) {
    var params = new URLSearchParams();
    if (next.type !== 'all') params.set('type', next.type);
    if (next.sort !== 'default') params.set('sort', next.sort);
    if (next.page !== 1) params.set('page', next.page);
    if (next.all) params.set('all', '1');
    var query = params.toString();
    return query ? '#' + query : '';
  }

  function nextState(changes) { return Object.assign({}, state, changes); }
  function matches(card, type) { return type === 'all' || card.types.indexOf(type) !== -1; }

  function pageItem(label, page, disabled, current, ariaLabel) {
    var li = document.createElement('li');
    var item = document.createElement(disabled || current ? 'span' : 'a');
    item.textContent = label;
    if (ariaLabel) item.setAttribute('aria-label', ariaLabel);
    if (disabled) {
      li.className = 'is-disabled';
      item.setAttribute('aria-disabled', 'true');
    } else if (current) {
      li.className = 'is-current';
      item.setAttribute('aria-current', 'page');
    } else {
      item.dataset.nbxPage = String(page);
      item.href = hashFor(nextState({ page: page })) || '#';
    }
    li.appendChild(item);
    return li;
  }

  function render(navigate) {
    var ordered = cards.slice().sort(function (a, b) {
      var availability = Number(b.available) - Number(a.available);
      var price = state.sort === 'default' ? 0 : (state.sort === 'price-asc' ? 1 : -1) * (a.price - b.price);
      return availability || price || a.initialIndex - b.initialIndex;
    });
    var visible = ordered.filter(function (card) { return matches(card, state.type); });
    var pages = Math.max(1, Math.ceil(visible.length / pageSize));
    state.page = state.all ? 1 : Math.min(state.page, pages);
    ordered.forEach(function (card) { card.node.hidden = true; grid.appendChild(card.node); });
    visible.forEach(function (card, index) {
      card.node.hidden = !state.all && (index < (state.page - 1) * pageSize || index >= state.page * pageSize);
    });
    root.querySelectorAll('[data-nbx-count]').forEach(function (counter) { counter.textContent = String(visible.length); });
    selects.forEach(function (select) { select.value = state.sort; });
    typeLinks.forEach(function (link) {
      var active = link.dataset.nbxType === state.type;
      var count = cards.filter(function (card) { return matches(card, link.dataset.nbxType); }).length;
      link.dataset.count = String(count);
      link.querySelector('.mbb-nbx-type__count').textContent = String(count);
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
      link.href = hashFor(nextState({ type: link.dataset.nbxType, page: 1 })) || '#';
    });
    var list = pagination.querySelector('ul');
    list.replaceChildren(pageItem('←', state.page - 1, state.page === 1, false, 'Page précédente'));
    for (var page = 1; page <= pages; page += 1) {
      list.appendChild(pageItem(String(page), page, false, page === state.page));
    }
    list.appendChild(pageItem('→', state.page + 1, state.page === pages, false, 'Page suivante'));
    pagination.hidden = state.all || pages <= 1;
    paginationReturn.hidden = !state.all;
    pagination.querySelector('[data-nbx-all]').href = hashFor(nextState({ all: true, page: 1 }));
    paginationReturn.querySelector('[data-nbx-all]').href = hashFor(nextState({ all: false, page: 1 })) || '#';
    var hash = hashFor(state);
    if (window.location.hash !== hash) {
      // History API updates preserve scroll, including when clearing the hash.
      var url = window.location.pathname + window.location.search + hash;
      if (navigate) window.history.pushState(window.history.state, '', url);
      else window.history.replaceState(window.history.state, '', url);
    }
  }

  function focusGrid(scroll) {
    grid.tabIndex = -1;
    grid.focus({ preventScroll: true });
    if (scroll) grid.scrollIntoView({ block: 'start' });
  }

  selects.forEach(function (select) {
    select.addEventListener('change', function () {
      state.sort = select.value;
      state.page = 1;
      render(true);
    });
  });
  typeLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      state.type = link.dataset.nbxType;
      state.page = 1;
      render(true);
      focusGrid(false);
    });
  });
  [pagination, paginationReturn].forEach(function (nav) {
    nav.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link || !nav.contains(link)) return;
      event.preventDefault();
      if (link.dataset.nbxAll !== undefined) {
        state.all = link.dataset.nbxAll === 'true';
        state.page = 1;
      } else if (link.dataset.nbxPage) state.page = Number(link.dataset.nbxPage);
      render(true);
      focusGrid(true);
    });
  });

  var cancelCartRefresh = null;
  function refreshCart(openDrawer) {
    if (cancelCartRefresh) cancelCartRefresh();
    var th = window.theme;
    if (openDrawer && th && th.settings && th.settings.afterAddition === 'redirect') {
      window.location.href = '/cart';
      return Promise.resolve(false);
    }
    return new Promise(function (resolve) {
      var done = false;
      var guard;
      var request;
      function finish(success, superseded) {
        if (done) return;
        done = true;
        clearTimeout(guard);
        cancelCartRefresh = null;
        // The theme writes the drawer/count before .done runs. Abort its jqXHR
        // on timeout or replacement so a stale response cannot reach that write.
        if ((!success || superseded) && request && typeof request.abort === 'function') {
          try { request.abort(); } catch (_) { /* Continue restoring the UI. */ }
        }
        if (success && openDrawer) {
          try { th.MiniCart.open(); } catch (_) { if (!superseded) success = false; }
        }
        if (!success) {
          // The theme only clears this state in its successful /search callback.
          document.querySelectorAll('.minicart.loading').forEach(function (cart) {
            cart.classList.remove('loading');
          });
          if (openDrawer && !superseded) window.location.href = '/cart';
        }
        resolve(success);
      }
      cancelCartRefresh = function () { finish(true, true); };
      guard = setTimeout(function () { finish(false); }, 6000);
      try {
        if (!window.theme || !window.theme.MiniCart || typeof th.MiniCart.update !== 'function') {
          finish(false);
          return;
        }
        request = th.MiniCart.update();
        if (request && typeof request.done === 'function' && typeof request.fail === 'function') {
          request.done(function () { finish(true); });
          request.fail(function () { finish(false); });
        } else if (request && typeof request.then === 'function') {
          request.then(function () { finish(true); }, function () { finish(false); });
        } else finish(false);
      } catch (_) { finish(false); }
    });
  }

  function messageFor(error) {
    if (error.name === 'AbortError') return 'Le panier ne répond pas. Réessayez dans un instant.';
    if (error.status === 422) {
      return error.json.description || error.json.message || "Cette box ne peut pas être ajoutée pour le moment : un produit qu'elle contient est indisponible.";
    }
    return "Impossible d'ajouter la box au panier. Réessayez ou contactez-nous.";
  }

  root.querySelectorAll('[data-nbx-form]').forEach(function (form) {
    var card = form.closest('.mbb-nbx-card');
    var button = form.querySelector('.mbb-nbx-btn');
    var label = button.querySelector('.mbb-nbx-btn__text');
    var message = form.querySelector('.mbb-nbx-card__msg');
    var quantity = form.querySelector('.mbb-nbx-qty__input');
    var busy = false;
    function restore() {
      busy = false;
      button.classList.remove('is-loading', 'is-added');
      label.textContent = 'Ajouter au panier';
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }
    form.querySelectorAll('[data-nbx-step]').forEach(function (control) {
      control.addEventListener('click', function () {
        if (control.disabled || card.dataset.available === 'false') return;
        quantity.value = String(Math.max(1, Math.min(20, (Number(quantity.value) || 1) + Number(control.dataset.nbxStep))));
      });
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      if (card.dataset.available === 'false' || button.disabled) {
        message.textContent = 'Cette box est épuisée pour le moment.';
        return;
      }
      busy = true;
      message.textContent = '';
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
      label.textContent = 'Ajout…';
      var timer;
      // Start inside the promise so synchronous API failures also restore the button.
      Promise.resolve().then(function () {
        var controller = new AbortController();
        timer = setTimeout(function () { controller.abort(); }, 15000);
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: Number(form.dataset.variantId), quantity: Math.max(1, Math.min(20, Number(quantity.value) || 1)) })
        });
      }).then(function (response) {
        return response.text().then(function (text) {
          var json = {};
          try { json = JSON.parse(text) || {}; } catch (_) { /* A non-JSON error uses the generic message. */ }
          return { ok: response.ok, status: response.status, json: json };
        });
      }).then(function (response) {
        clearTimeout(timer);
        if (!response.ok) throw Object.assign(new Error('add'), { status: response.status, json: response.json });
        return refreshCart(true);
      }).then(function (refreshed) {
        if (!refreshed) { restore(); return; }
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        label.textContent = 'Ajoutée ✓';
        setTimeout(restore, 2000);
      }).catch(function (error) {
        clearTimeout(timer);
        message.textContent = messageFor(error);
        restore();
        // A 422 can still add the available quantity. Reconcile counts and drawer
        // contents without opening it or replacing the stock error with success.
        if (error.status === 422) refreshCart(false);
      });
    });
  });

  var filterToggle = root.querySelector('.mbb-nbx-filtertoggle');
  filterToggle.addEventListener('click', function () {
    var open = root.querySelector('#mbbNbxPanel').classList.toggle('is-open');
    filterToggle.setAttribute('aria-expanded', String(open));
  });
  root.querySelectorAll('.mbb-nbx-faq__q').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('.mbb-nbx-faq__item');
      var open = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
      root.querySelector('#' + button.getAttribute('aria-controls')).hidden = !open;
      button.querySelector('.mbb-nbx-faq__plus').textContent = open ? '−' : '+';
    });
  });

  var scheduled = false;
  function updateStickyTop() {
    var header = document.querySelector('.header-sticky__placeholder.stick .header-sticky');
    headerHeight = header ? header.getBoundingClientRect().height : 0;
    root.style.setProperty('--mbb-nbx-top', headerHeight + 'px');
    scheduled = false;
  }
  function scheduleStickyTop() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateStickyTop);
  }
  window.addEventListener('scroll', scheduleStickyTop, { passive: true });
  window.addEventListener('resize', scheduleStickyTop);
  function restoreNavigation() {
    readHash();
    render(false);
  }
  window.addEventListener('hashchange', restoreNavigation);
  window.addEventListener('popstate', restoreNavigation);
  updateStickyTop();
  readHash();
  render(false);
}());
